import React from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {UserTypeFilters, UserTypeTitles} from "root/DataFunctions/Constants";

const MyContributorsAppBodyHeader= (props) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const {pathname}  = useLocation();

    const buildHeader = (header, sub_header) =>{
        const pageHeader = <h4 className="title">{header} {sub_header}</h4>;
        return pageHeader;
    }

    const displayHeader = () =>
    {
        if(pathname.includes('/dashboard')){
            //check if we have a user's name on the url
            const user_name= queryParams.name;
            const user_name_string =  user_name !== undefined ? 'for ' + queryParams.name : '';
            return buildHeader('Dashboard', user_name_string);
        }
        else{
            //Default to details
            return buildHeader(UserTypeTitles.MY_CONTRIBUTORS);
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default MyContributorsAppBodyHeader;
